module.exports = __webpack_public_path__ + "static/img/__9235.b12c8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9235.jpg
// module id = Pnbc
// module chunks = 0